import { debounce } from './utils';

import { createLogger } from '@/lib/logger';

document.addEventListener('DOMContentLoaded', function () {
  const messages = document.querySelectorAll<HTMLDivElement>('.announcement-banner-message');
  let intervalId: number = 0;
  const log = createLogger('eyebrow-banner');

  // Update threshold money for each message
  messages.forEach((msg) => {
    const priceThreshold = msg.getAttribute('data-price');
    const currencyRate = parseFloat(window.Shopify.currency.rate || '1');
    const thresholdAmount = parseInt(priceThreshold || '0') * (currencyRate);
    const currencySymbol = msg.getAttribute('data-currency-symbol') || '$';
    const thresholdDisplayAmount = `${currencySymbol}${thresholdAmount.toFixed(0)}`;

    msg.textContent = msg.textContent?.replace('threshold_money', thresholdDisplayAmount);
  });

  function clearMessages() {
    messages.forEach((msg) => (msg.style.display = 'none'));
  }

  function handleDesktop() {
    log.info('handle desktop');
    clearMessages();
    clearInterval(intervalId);
    messages.forEach((msg) => (msg.style.display = 'inline'));
  }

  function handleTablet() {
    log.info('handle tablet');
    clearMessages();
    clearInterval(intervalId);
    let index = 0;
    messages[index].style.display = 'inline';
    messages[(index + 1) % messages.length].style.display = 'inline';

    intervalId = setInterval(() => {
      clearMessages();
      messages[index].style.display = 'inline';
      messages[(index + 1) % messages.length].style.display = 'inline';
      index = (index + 2) % messages.length;
    }, 10000);
  }

  function handleMobile() {
    log.info('handle mobile');
    clearMessages();
    clearInterval(intervalId);
    let index = 0;
    messages[index].style.display = 'inline';

    intervalId = setInterval(() => {
      clearMessages();
      messages[index].style.display = 'inline';
      index = (index + 1) % messages.length;
    }, 5000);
  }

  function updateDisplayMode() {
    // Clear all messages and intervals when updating mode
    clearMessages();
    clearInterval(intervalId);
    log.info('update display mode');
    if (window.innerWidth >= 1024) handleDesktop();
    else if (window.innerWidth >= 768) handleTablet();
    else handleMobile();

    const wrapper = document.querySelector('.announcement-banner-container');

    if (wrapper) {
      wrapper.classList.add('loaded');
    }
  }

  // Initial display mode setup
  updateDisplayMode();

  // Update display mode on resize
  window.addEventListener('resize', debounce(updateDisplayMode, 200));
});
